<template>
    <div class="d-flex flex-column gap-2 justify-content-center align-items-center" >
      <h3 data-aos="fade-left" >{{ $t('ac_cleaning.why_beneat_section.title') }}</h3>
      <small data-aos="fade-right" >{{ $t('ac_cleaning.why_beneat_section.subtitle') }}</small>
      <div class="cards">
        <div v-for="(item, index) in beneat" :key="index" class="border"
          :data-aos="Math.floor(index  / 3) % 2 === 0 ? 'fade-right' : 'fade-left'"
        >
          <img :src="`/static/img/acCleaning/svg/${item.image}`" class="img" />
          <h5 >
            <!-- {{ item.title }} -->
            {{ $t(`ac_cleaning.why_beneat_section.benefits.${index}.title`) }}
          </h5>
          <!-- <small v-html="item.description"></small> -->
          <small v-html="$t(`ac_cleaning.why_beneat_section.benefits.${index}.description`)"></small>
          <img :src="`/static/img/acCleaning/svg/${item.image}`" class="bg-img" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        title: 'ทำไมต้องเลือก BeNeat?',
        subtitle: 'เพราะแอร์สะอาดคือ จุดเริ่มต้นของบ้านที่สุขภาพดี',
        beneat: [
          {
            title: 'ทีมให้บริการมืออาชีพ',
            description: `ทีมให้บริการมืออาชีพ ผ่านการอบรมด้าน การล้างแอร์โดยเฉพาะ และมีการตรวจ สอบประวัติอาชญากรรมก่อนรับเข้าระบบ`,
            image: 'hugeicons_user-group-02.svg'
          },
          {
            title: 'ให้บริการอย่างเป็นระบบ',
            description: `ให้บริการอย่างเป็นระบบ โดยมีหัวหน้าทีม ควบคุมคุณภาพทุกครั้ง`,
            image: 'hugeicons_structure-check.svg'
          },
          {
            title: 'มีการรับประกัน',
            description: `รับประกัน 14 วัน (ครอบคลุม อาการผิดปกติและความเสียหาย จากการล้าง)`,
            image: 'hugeicons_checkmark-badge-01.svg'
          },
          {
            title: 'อุปกรณ์ที่มีคุณภาพ',
            description: `มาพร้อมกับอุปกรณ์เฉพาะทางที่ได้มาตรฐาน`,
            image: 'hugeicons_lift-truck.svg'
          },
          {
            title: 'รวมค่าเดินทางแล้ว',
            description: `ราคาค่าบริการรวมค่าเดินทางแล้ว ทางเราไม่ได้คิดค่าเดินทางเพิ่ม`,
            image: 'hugeicons_car-01.svg'
          },
          {
            title: 'ประกันความเสียหาย',
            description: `แอร์สี่ทิศทาง ผ่านการอบรบและตรวจสอบ ประวัติอาชญากรรมแล้ว`,
            image: 'hugeicons_spam.svg'
          },
          {
            title: 'Customer Service',
            description: `อุ่นใจกับทีมงานแอดมินบีนีทคอยดูแลอำนวย ความสะดวก`,
            image: 'hugeicons_customer-service-01.svg'
          },
          {
            title: 'ใส่ใจพื้นที่ให้บริการ',
            description: `ดูแลพื้นที่บริการอย่างใส่ใจ ทีมงาน จัดการทำความสะอาดบริเวณที่ ให้บริการหลังเสร็จงาน เพื่อให้ คุณสะดวกสบายยิ่งขึ้น`,
            image: 'hugeicons_service.svg'
          }
        ]
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';
  h3 {
    font-size: 32px;
    font-weight: 600;
    color: black;
    text-align: center;
    margin: 5% 0 8px;
  }
  
  .cards {
    display: grid;
    grid-template-columns: auto;
    gap: 30px;
  }
  
  .border {
    border: 1px solid;
    border-radius: 24px;
    border-color: #34C2D8;
    padding: 30px;
    text-align: left;
    position: relative;
  }

  .img {
    width: 64px;
    height: 64px;
  }
  
  .bg-img {
    opacity: 8%;
    position: absolute;
    right: 20px;
    bottom: 8px;
    width: 102px;
    height: 102px;
  }
  
  @media (min-width: 1024px) {
    .cards {
      grid-template-columns: 32% 32% 32%;
      justify-content: space-between;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/WhyBeNeat.vue